<template>
  <div class="text-center">
    <small class="text-muted d-block text-uppercase fw-bold mb-2" style="font-size: 11px; letter-spacing: 0.8px;">
      <i class="fa-solid fa-pen-nib me-1 text-primary"></i> Unterschrift zeichnen
    </small>
    <canvas ref="canvasRef" width="350" height="200" style="border: 1px solid rgb(208, 208, 208);"></canvas>
  </div>

  <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center mt-3 pt-3 border-top w-100">
    <button type="button" class="btn btn-soft-red fw-bold me-0 me-sm-3 px-4" style="min-height: 38px;" :disabled="isSaving" @click="clearSignature">
      <i class="fa-solid fa-eraser me-2"></i> Löschen
    </button>
    <button type="button" class="btn btn-primary fw-bold mt-3 mt-sm-0 px-4" style="min-height: 38px;" :disabled="isSaving" @click="submitSignature">
      <i class="fa-solid fa-signature me-2"></i> Unterschreiben
    </button>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, defineProps, onMounted, ref} from 'vue';
import SignaturePad from 'signature_pad';
import {WarningToast} from '@/components/VueToast';

defineProps<{ isSaving: boolean }>();

const emit = defineEmits<{ (e: 'sign', digitalSignature: string): void }>();

const canvasRef = ref<HTMLCanvasElement | null>(null);
let signaturePad: SignaturePad | null = null;

function clearSignature() {
  signaturePad?.clear();
}

function submitSignature() {
  if (!signaturePad || signaturePad.isEmpty()) {
    WarningToast('Bitte zeichnen Sie Ihre Unterschrift.');
    return;
  }

  emit('sign', signaturePad.toDataURL('image/png'));
}

onMounted(() => {
  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }
});
</script>

<style scoped>
canvas {
  cursor: crosshair;
  max-width: 100%;
}

.btn-soft-red {
  color: #a51d24;
  background-color: #fce8e6;
  border: 1px solid #f8c2be;
  transition: all 0.15s ease-in-out;
}

.btn-soft-red:hover {
  color: #ffffff;
  background-color: #a51d24;
  border-color: #a51d24;
}
</style>
